import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 130px;
    height: 100%;
    align-self: stretch;
`;

export const Head = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
`;

export const Icon = styled.div`
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 10px;
    overflow: hidden;
`;

export const Body = styled.div`
    margin-bottom: 20px;
`;

export const Foot = styled.div`
    padding: 20px 0;
`;

export const Title = styled.div`
    font-size: 16px;
    line-height: 1.38;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
`;

export const Description = styled.div`
    font-size: 14px;
    line-height: 1.4;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
`;
